import { Truck, ShieldCheck, Wrench, Award } from "lucide-react";

export const DEFAULT_HOME_HIGHLIGHTS = [
    { icon: "truck", title: "Envío 48h", description: "Nacional a toda la república mexicana" },
    { icon: "shield", title: "Garantía total", description: "Productos originales con garantía de fábrica" },
    { icon: "wrench", title: "Asesoría técnica", description: "Expertos para resolver tu proyecto" },
    { icon: "award", title: "Mejores precios", description: "Precios competitivos para profesionales" },
];

export const HIGHLIGHT_ICON_OPTIONS = [
    { value: "truck", label: "Envío / camión" },
    { value: "shield", label: "Garantía / escudo" },
    { value: "wrench", label: "Herramienta / asesoría" },
    { value: "award", label: "Premio / precios" },
];

const ICON_MAP = {
    truck: Truck,
    shield: ShieldCheck,
    wrench: Wrench,
    award: Award,
};

export function normalizeHomeHighlights(raw) {
    if (!Array.isArray(raw) || raw.length === 0) return [...DEFAULT_HOME_HIGHLIGHTS];
    return raw.map((item, idx) => {
        const fallback = DEFAULT_HOME_HIGHLIGHTS[idx] || DEFAULT_HOME_HIGHLIGHTS[0];
        const icon = ICON_MAP[item?.icon] ? item.icon : fallback.icon;
        return {
            icon,
            title: (item?.title || fallback.title).trim(),
            description: (item?.description || fallback.description).trim(),
        };
    });
}

export function emptyHighlight() {
    return { icon: "truck", title: "Nuevo bloque", description: "Descripción" };
}

export function HighlightIcon({ name, className = "w-7 h-7" }) {
    const Icon = ICON_MAP[name] || Truck;
    return <Icon className={className} />;
}
